export function parseNumber(value?: string | number | null): number | null {
  if (typeof value === 'number') {
    return value;
  }

  if (!value) {
    return null;
  }

  const parsedValue = parseFloat(value);

  if (isNaN(parsedValue)) {
    return null;
  } else {
    return parsedValue;
  }
}
